import { render, staticRenderFns } from "./ConfigureJob.vue?vue&type=template&id=783304d6&"
import script from "./ConfigureJob.vue?vue&type=script&lang=ts&"
export * from "./ConfigureJob.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports